import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';

const SetItemSmalltxtef = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const [smalltxtdelay, setSmalltxtdelay] = useState(currentSingle[props.delay]);
    const [smalltxtduration, setSmalltxtduration] = useState(currentSingle[props.duration]);

    const [smalltxtColor, setSmalltxtColor] = useState(currentSingle[props.txtColor]);

    const [smalltxtEffect, setSmalltxtEffect] = useState(currentSingle[props.effect]);

    useEffect(() => {

    }, [])
    return (
        <div className={"col-md-3 mb-2 onRight"}>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>צבע טקסט</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={smalltxtColor} style={{ direction: "ltr" }}
                        onChange={(e) => { currentSingle[props.txtColor] = e.target.value; setSmalltxtColor(e.target.value) }} required />

                </div>
            </div>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>אפקט</label>
                <div className={"input-group"}>
                    <select defaultValue={smalltxtEffect} style={{ direction: "ltr" }}
                        onChange={(e) => { currentSingle[props.effect] = e.target.value; setSmalltxtEffect(e.target.value) }}>

                        {myFunctions.animateList().map((itm, indx) => {
                            return (
                                <option key={indx}>
                                    {itm}
                                </option>
                            )
                        })}
                    </select>
                </div>
            </div>



            <div className={"col-md-6 mb-2 onRight"}>
                <label>Duration (0-5)</label>
                <div className={"input-group"}>
                    <input type={"number"} max={5} min={0} className={"form-control"} id={"validationCustom02"} placeholder={""}
                        value={smalltxtduration} style={{ direction: "ltr" }}
                        onChange={(e) => { currentSingle[props.duration] = e.target.value; setSmalltxtduration(e.target.value) }} />

                </div>
            </div>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>Delay</label>
                <div className={"input-group"}>
                    <SelectImgDelay currentDelay={smalltxtdelay ? smalltxtdelay : ""}
                        theFunction={(fUrl) => { currentSingle[props.delay] = fUrl; setSmalltxtdelay(fUrl) }} />

                </div>
            </div>

        </div >


    );
}

export default SetItemSmalltxtef;